import React from 'react'
import styled from 'styled-components'
import { Facebook } from '../assets/Icons/Facebook'
import { Instagram } from '../assets/Icons/Instagram'

export const ProgramMay2026: React.FC = () => {
  return (
    <Root>
      <PageHeadingContainer>
        <Logo src={require('../assets/katla-logo.png')} />
        <PageTitle>Ekkert mál!</PageTitle>
        <PageSubTitle>- Kvennakórinn Katla - </PageSubTitle>

        <PageInstructions>
          <ProgramList>
            <ProgramListItem>
              <strong>Leyndarmál</strong> - Ásgeir Trausti
              <ProgramListInfo>Útsetning: Stefán Þorleifsson</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Glory Box</strong> - Portishead
              <ProgramListInfo>
                Útsetning: Jake Alexander <br />
                Aðlögun: Lilja og Hildigunnur
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Don't Kill My Vibe</strong> - Sigrid
              <ProgramListInfo>
                Útsetning: Hildigunnur Einarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>White Rabbit</strong> - Jefferson Airplane
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Hide and Seek</strong> - Imogen Heap
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Water Fountain</strong> - Tune-Yards
              <ProgramListInfo>Útsetning: María Magnúsdóttir</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Í löngu máli</strong> - Una Torfa
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Freedom</strong> - Gunnar Bjarni Ragnarsson / Sigríður
              Guðnadóttir
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Frozen</strong> - Madonna
              <ProgramListInfo>Útsetning: Jake Alexander</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Fjólublátt ljós við barinn</strong> - Gunnar Þórðarsson
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Where the Hell is My Husband</strong> - RAYE
            </ProgramListItem>
            <ProgramListItem>
              <strong>Ekkert mál</strong> - Ragnhildur Gísladóttir
              <ProgramListInfo>
                Útsetning: Stefán Þorleifsson <br />
                Aðlögun: Lilja og Hildigunnur
              </ProgramListInfo>
            </ProgramListItem>
          </ProgramList>
        </PageInstructions>
      </PageHeadingContainer>
      <SoMeWrapper>
        <h3>Fylgið okkur á samfélagsmiðlum:</h3>
        <AdLink
          href="https://www.facebook.com/kvennakorinnkatla"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Facebook />
        </AdLink>
        <AdLink
          href="https://www.instagram.com/kvennakorinn_katla/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram />
        </AdLink>
      </SoMeWrapper>
      <AdSection>
        <AdTextWrapper>
          <AdTitle>Kvennakórinn Katla þakkar:</AdTitle>
          <AdLine>Mynstra</AdLine>
          <AdLine>Borgarsjóði Reykjavíkurborgar</AdLine>
        </AdTextWrapper>
        <AdLogosWrapper>
          {/* <AdWrapper>
                <AdLink href="https://www.ojk.is/">
                  <Ad src={require('../assets/logo-efnisskra-2022/ojk.jpg')}></Ad>
                </AdLink>
              </AdWrapper> */}
          {/* <AdWrapper>
                <AdLink href="https://www.isam.is/">
                  <Ad src={require('../assets/logo-efnisskra-2022/isam.jpg')}></Ad>
                </AdLink>
              </AdWrapper>  */}
          {/* <AdWrapper>
                <AdLink href="https://www.mena.is/">
                  <Ad
                    src={require('../assets/logo-efnisskra-2022/mena-litid.png')}
                  ></Ad>
                </AdLink>
              </AdWrapper>  */}

          <AdWrapper>
            <AdLink
              href="https://www.tm.is/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Ad src={require('../assets/logo-efnisskra-2026/tm.avif')}></Ad>
            </AdLink>
          </AdWrapper>
          <AdWrapper>
            <AdLink
              href="https://www.audur.is/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Ad src={require('../assets/logo-efnisskra-2026/audur.jpg')}></Ad>
            </AdLink>
          </AdWrapper>

          {/* <AdWrapper>
                <AdLink href="https://www.unique.is/">
                  <Ad src={require('../assets/logo-efnisskra-2022/unique.png')}></Ad>
                </AdLink>
              </AdWrapper> */}
          {/* <AdWrapper>
                <AdLink href="https://www.dekra.is/">
                  <Ad
                    src={require('../assets/logo-efnisskra-2022/nailberry_logo.png')}
                  ></Ad>
                </AdLink>
              </AdWrapper> */}
        </AdLogosWrapper>
        <AdLogosWrapper>
          <AdWrapperSmall>
            <AdLink
              href="https://www.vegmuli.is/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Ad
                src={require('../assets/logo-efnisskra-2026/tannlaeknar-vegmula.jpg')}
              ></Ad>
            </AdLink>
          </AdWrapperSmall>
        </AdLogosWrapper>
      </AdSection>
    </Root>
  )
}

const Root = styled.div`
  font-family: Geometria;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: rgba(225, 173, 157, 0.8);
  padding: 2rem 4rem;
  min-height: 100vh;

  .border-bottom {
    border-bottom: 0.125rem solid rgba(128, 128, 128, 0.2);
  }

  @media screen and (max-width: 800px) {
    padding: 1.5rem;
  }
`
const PageHeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  max-width: 65rem;

  margin-top: 5rem;
  @media screen and (max-width: 800px) {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
  @media screen and (max-width: 640px) {
    margin-top: 0;
  }
`
const Logo = styled.img`
  height: 6rem;
  width: 6rem;
`
const PageTitle = styled.h1`
  font-family: Geometria-Medium;
  font-size: 4rem;

  margin-top: 1rem;

  @media screen and (max-width: 800px) {
    font-size: 3rem;
  }
`
const PageSubTitle = styled.h3`
  font-family: Geometria-Medium;
  margin-top: -2.5rem;
  margin-bottom: 2.5rem;

  @media screen and (max-width: 800px) {
    margin-top: -1.5rem;
  }
`
const PageInstructions = styled.div`
  font-size: 1.25rem;
`

const ProgramList = styled.ol`
  font-size: 1rem;
  text-align: left;
  padding-left: 0;
  margin-left: 4rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 800px) {
    margin-left: 2rem;
  }
`

const ProgramListItem = styled.li`
  margin-bottom: 1rem;
  font-size: 1rem;

  & > a {
    text-decoration: none;
    font-size: 1rem;
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
`

const ProgramListInfo = styled.p`
  font-size: 0.875rem;
  margin-top: 0.25rem;
`

const SoMeWrapper = styled.div`
  font-size: 1rem;
  margin-bottom: 1rem;
`

const AdSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 0 0 5rem 0;

  @media screen and (max-width: 1620px) {
    /* color: magenta; */
  }
`
const AdTextWrapper = styled.div``

const AdTitle = styled.h3``

const AdLine = styled.p`
  font-weight: bold;
  font-size: 2rem;
`
const AdLogosWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    margin: 0 0 0.5rem 0;
    width: 100%;
  }
`

const AdWrapper = styled.div`
  margin: 0 0.5rem;

  margin-bottom: 1rem;

  @media screen and (max-width: 900px) {
    margin-left: 5rem;
    margin-right: 5rem;
    margin-bottom: 0;
  }

  @media screen and (max-width: 768px) {
    margin: 0 0 0.5rem 0;
    width: 100%;
  }
`
const AdWrapperSmall = styled(AdWrapper)`
  height: 50%;
  width: 50%;
  img {
    height: 25%;
    width: 25%;
  }

  @media screen and (max-width: 768px) {
    height: 100%;
    width: 100%;
    img {
      height: 35%;
      width: 35%;
    }
  }
`

const AdLink = styled.a`
  max-height: 100%;
  max-width: 100%;

  &:first-of-type svg {
    margin-right: 2rem;
  }
`

const Ad = styled.img`
  max-width: 100%;
  max-height: 100%;

  /* @media screen and (min-width: 800px) {
    max-width: 55vw;
  } */

  @media screen and (min-width: 1310px) {
    height: 22rem;
  }

  @media screen and (max-width: 900px) {
    margin: 0;
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    margin: 0;
    width: 100%;
  }
`

/* #e1ad9d */
